import { useEffect, useState } from "react";
import { CardIcon } from "../../../../Layout/Common/CardIcon";
export const MasterCardPayment = ({ handleOnCheck, card }) => {
  if (card && card.card_number && card.card_exp && card.card_isExpired == false) {
    return (
      <div className="change-accountShip shipPayment">
        <div className="shipping-method payment-card-list border-container" id="master-card">
          <div className="shipping-method-info pay-option active" data-group={1} data-type="masterCard">
            <div>
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="mastercardType"
                value="MC"
                onChange={() => handleOnCheck("MC")}
              />
            </div>
            {card && (
              <label className="form-check-label" htmlFor="mastercardType">
                <div className="full-width d-flex align-items-center" style={{ gap: "10px", minWidth: "50px" }}>
                  <div className="pay-icon">
                    <CardIcon cardType={card.card_type} />
                  </div>
                  <span>
                    Card Ending in <b>*{card.card_number}</b>
                    <span className="savedCard-exp">
                      Expiry: <b>{card.card_exp}</b> {String(card.card_name).slice(0, 18)}
                    </span>
                  </span>
                </div>
              </label>
            )}
          </div>
        </div>
      </div>
    );
  } else return null;
};
